import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

/**
 * Interface que define a estrutura esperada da resposta do perfil
 */
export interface UserProfile {
  user_id: number;
  first_name: string;
  middle_name: string | null;
  last_name: string;
  email: string;
  phone_number?: string | null;
  language?: number | null;
  country: string | null;
  state: string | null;
  city: string | null;
  address: string | null;
  postal_code: string | null;
  sms_notification: string;
  avatarUrl?: string | null;
  created_at: string;
  updated_at: string;
  completion_percentage: number;
  [key: string]: any;
}

/**
 * Interface para a organização vinculada ao usuário (se houver)
 */
export interface Organization {
  org_id: number;
  org_name: string;
  email?: string;
  phone?: string;
  country: string;
  state: string;
  city: string;
  address: string;
  postal_code: string;
  created_at: string;
  updated_at: string;
}

/**
 * Interface para grupo(s) vinculado(s) ao usuário (se houver)
 */
export interface Group {
  group_id: number;
  group_name: string;
  members_count: number;
}

export interface Role {
  role_id: number;
  role_name: string;
}

/**
 * Interface de resposta final da API de perfil
 */
export interface ProfileResponse {
  success: boolean;
  message: string;
  data: UserProfile;
  organization?: Organization | null;
  groups?: Group[];
  role?: Role | null;
}

export interface UpdateProfileRequest {
  first_name: string;
  middle_name?: string | null | undefined;
  last_name: string;
  phone_number?: string | null | undefined;
  language?: number | null;
  country?: string | null | undefined;
  state?: string | null | undefined;
  city?: string | null | undefined;
  address?: string | null | undefined;
  postal_code?: string | null | undefined;
  sms_notification: string;
  avatarUrl?: string | null | undefined;
}

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private readonly apiUrl = `${environment.apiUrl}/profile`;

  constructor(private http: HttpClient) {}

  /**
   * Requisição para obter os dados do perfil do usuário autenticado.
   * Retorna informações básicas, organização e grupos (se houver).
   *
   * @returns Observable contendo os dados estruturados do perfil
   */
  getProfile(): Observable<ProfileResponse> {
    return this.http.get<ProfileResponse>(this.apiUrl);
  }

  /**
   * Requisição para atualizar o perfil do usuário autenticado.
   * Apenas os campos permitidos na API podem ser enviados.
   *
   * @param data Objeto contendo os campos a serem atualizados
   * @returns Observable da resposta da API
   */
 

  updateProfile(data: UpdateProfileRequest) {
    return this.http.put(`${environment.apiUrl}/profile`, data);
  }
}
